import {ReactSlick} from '@crema/modules/thirdParty';
export default ReactSlick;
